import React from "react"
import PropTypes from "prop-types"
import { ResponsiveBump } from '@nivo/bump'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'

export default function BumpChart(props) {
  const breakpoints = useBreakpoint();
  const chartData = []

  function trunctateString(string) {
    const length = breakpoints.sm ? 11 : 100
    return (string.length > length) ? string.substr(0, length-1) + '...' : string
  }

  let marginRight = 140
  let marginLeft = 140

  if (breakpoints.sm) {
    marginLeft = 10
    marginRight = 100
  }

  props.xmlChildren.map(child => {
    // eslint-disable-next-line no-prototype-builtins
    if(child.hasOwnProperty("children")){
      return (
        chartData.push({
          "id": trunctateString(child.attributes.response),

          "data": child.children.map(yearData => {
            const ranking =  Number(yearData.attributes.ranking) > 0 ?  Number(yearData.attributes.ranking) : null
            return (
              {
                "x": Number(yearData.content),
                "y": ranking
              }
            )
          })
        })
      )
    } else {
      return (
        console.log("There was an error with this bump chart. Probably missing multiyear data.", props.xmlChildren)
      )
    }
  })

  return (
    <ResponsiveBump
      data={chartData}
      margin={{ top: 40, right: marginRight, bottom: 40, left: marginLeft }}
      // colors={props.custom_scheme}
      colors={{ scheme: 'category10' }}
      lineWidth={breakpoints.sm ? 1 : 3}
      activeLineWidth={breakpoints.sm ? 3 : 6}
      inactiveLineWidth={breakpoints.sm ? 1 : 3}
      inactiveOpacity={0.15}
      pointSize={breakpoints.sm ? 5 : 10}
      activePointSize={16}
      inactivePointSize={0}
      pointColor={{ theme: 'background' }}
      pointBorderWidth={3}
      activePointBorderWidth={3}
      pointBorderColor={{ from: 'serie.color' }}
      startLabel={breakpoints.sm ? false : 'id'}
      startLabelTextColor='#333333'
      endLabelTextColor='#333333'
      animate={false}
      axisTop={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: breakpoints.sm ? 90 : 0,
          legend: '',
          legendPosition: 'middle',
          legendOffset: -36
      }}
      axisRight={null}
      axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: breakpoints.sm ? 90 : 0,
          legend: '',
          legendPosition: 'middle',
          legendOffset: 32
      }}
      axisLeft={null}
      // axisLeft={{
      //     tickSize: 5,
      //     tickPadding: 5,
      //     tickRotation: 0,
      //     legend: 'ranking',
      //     legendPosition: 'middle',
      //     legendOffset: -40
      // }}
    />
  )
}

BumpChart.propTypes = {
  xmlChildren: PropTypes.array.isRequired,
  question: PropTypes.string.isRequired,
  custom_scheme: PropTypes.array.isRequired,
}

BumpChart.defaultProps = {
  xmlChildren: [],
  question: null,
  custom_scheme: { scheme: 'nivo' },
}
